// ---Third-party imports
import {useEffect} from 'react'

// ---Framework imports
import {Actions} from 'uix/registries'
import {getUtilityChunk} from 'uix/chunks/loader'
import log from 'uix/logging'
import {Graphics} from 'graphics'

// ---Local imports
import {useSelector, useActions} from './redux'

// ---Exports

export const useChunk = name => {
  /* load and return chunk namespace
  return null during load
  it's assumed, that you will take a fallback rendering decision during null state
  */

  // #if process.env.UIX_CHUNKED === 'false'
//   return getUtilityChunk(name)
  // #endif

  let loadedChunks = useSelector(root => root.meta.chunks.loaded)
  let loadChunks = useActions(Actions.loadChunks)
  let res = null
  useEffect(() => {
    if (!loadedChunks.includes(name)) {
      loadChunks([name])
    }
  }, [loadedChunks])

  if (loadedChunks.includes(name)) {
    res = getUtilityChunk(name)
  }
  return res
}

export const useGraphics = names => {
  // #if process.env.UIX_CHUNKED === 'false'
//   return Graphics
  // #endif

  let graphics = useSelector(root => root.meta.graphics)
  let loadGraphics = useActions('loadGraphics')
  useEffect(() => {
    if (names.some(n => !graphics[n])) {
      loadGraphics(names)
    }
  }, [])
  return graphics
}
